import React from 'react';
import { Link } from 'react-router-dom';

const CatalogOptimization = () => {
  return (
    <div style={pageStyle}>
      
      {/* --- NAVIGATION --- */}
      <nav style={navStyle}>
        <Link to="/" style={logoStyle}>PROMICON</Link>
        <div style={{ display: 'flex', gap: '20px' }}>
          <Link to="/" style={{ color: '#94a3b8', textDecoration: 'none' }}>Home</Link>
          <Link to="/contact-us" style={ctaLink}>Audit My Catalog</Link>
        </div>
      </nav>

      {/* --- HERO SECTION --- */}
      <section style={heroStyle}>
        <div style={badgeStyle}>SKU-LEVEL EFFICIENCY</div>
        <h1 style={h1Style}>
          E-commerce <span style={{ color: '#10b981' }}>Catalog Optimization</span>
        </h1>
        <p style={pStyle}>
          A messy catalog kills conversions. We clean, categorize, and optimize your 
          entire product database to improve search discoverability, customer 
          navigation, and backend inventory management.
        </p>
      </section>

      {/* --- OPTIMIZATION PILLARS --- */}
      <div style={gridStyle}>
        {/* Pillar 1 */}
        <div style={cardStyle}>
          <div style={iconBox}>🗂️</div>
          <h3 style={{ color: '#10b981', marginBottom: '10px' }}>Taxonomy & Hierarchy</h3>
          <p style={{ color: '#94a3b8', fontSize: '0.95rem' }}>
            Structuring your categories and sub-categories so customers can 
            find products in 3 clicks or less.
          </p>
        </div>

        {/* Pillar 2 */}
        <div style={cardStyle}>
          <div style={iconBox}>🏷️</div>
          <h3 style={{ color: '#10b981', marginBottom: '10px' }}>Attribute Mapping</h3>
          <p style={{ color: '#94a3b8', fontSize: '0.95rem' }}>
            Ensuring every SKU has accurate tags, colors, sizes, and technical 
            specs for precise filtering and search results.
          </p>
        </div>

        {/* Pillar 3 */}
        <div style={cardStyle}>
          <div style={iconBox}>🔄</div>
          <h3 style={{ color: '#10b981', marginBottom: '10px' }}>Variation Strategy</h3>
          <p style={{ color: '#94a3b8', fontSize: '0.95rem' }}>
            Properly grouping parent-child variations (colors/sizes) to 
            aggregate reviews and improve the user shopping experience.
          </p>
        </div>

        {/* Pillar 4 */}
        <div style={cardStyle}>
          <div style={iconBox}>🧹</div>
          <h3 style={{ color: '#10b981', marginBottom: '10px' }}>Data Scrubbing</h3>
          <p style={{ color: '#94a3b8', fontSize: '0.95rem' }}>
            Removing duplicate listings and fixing broken images or 
            descriptions to maintain a "Gold Standard" catalog.
          </p>
        </div>
      </div>

      {/* --- COMPARISON SECTION --- */}
      <section style={tableSection}>
        <h2 style={{ fontSize: '2.5rem', marginBottom: '40px' }}>Clean Data = More Sales</h2>
        
        <div style={tableContainer}>
          <div style={tableRow}>
            <div style={tableHeader}>Feature</div>
            <div style={tableHeader}>Standard Catalog</div>
            <div style={tableHeader}>Optimized Catalog</div>
          </div>
          <div style={tableRow}>
            <div style={tableCell}>Search Visibility</div>
            <div style={tableCell}>Fragmented</div>
            <div style={tableCell}><span style={{color: '#10b981'}}>Maximum Indexing</span></div>
          </div>
          <div style={tableRow}>
            <div style={tableCell}>Customer Journey</div>
            <div style={tableCell}>Confusing / Cluttered</div>
            <div style={tableCell}><span style={{color: '#10b981'}}>Seamless / Logical</span></div>
          </div>
          <div style={tableRow}>
            <div style={tableCell}>Inventory Sync</div>
            <div style={tableCell}>High Error Rate</div>
            <div style={tableCell}><span style={{color: '#10b981'}}>100% Reliable</span></div>
          </div>
        </div>
      </section>

      {/* --- FOOTER --- */}
      <footer style={footerStyle}>
        <p>© 2026 Promicon Digital. Precision at Scale.</p>
      </footer>
    </div>
  );
};

/* --- STYLES --- */

const pageStyle = { backgroundColor: '#07090e', color: 'white', minHeight: '100vh', fontFamily: 'Inter, sans-serif' };
const navStyle = { padding: '20px 50px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #1e293b' };
const logoStyle = { color: 'white', fontWeight: 'bold', textDecoration: 'none', fontSize: '1.4rem' };
const ctaLink = { color: '#ffffff', textDecoration: 'none', fontWeight: 'bold', border: '1px solid #10b981', padding: '8px 16px', borderRadius: '4px' };
const heroStyle = { padding: '100px 20px 60px', textAlign: 'center', background: 'linear-gradient(to bottom, #062019 0%, #07090e 100%)' };
const badgeStyle = { marginBottom: '20px', display: 'inline-block', padding: '8px 20px', borderRadius: '50px', background: 'rgba(16, 185, 129, 0.1)', border: '1px solid #10b981', color: '#10b981', fontSize: '0.85rem', fontWeight: 'bold' };
const h1Style = { fontSize: '3.5rem', marginBottom: '20px', fontWeight: '800' };
const pStyle = { fontSize: '1.15rem', color: '#94a3b8', maxWidth: '800px', margin: '0 auto', lineHeight: '1.6' };
const gridStyle = { padding: '40px 20px', maxWidth: '1100px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '25px' };
const cardStyle = { padding: '35px', backgroundColor: '#0f172a', borderRadius: '15px', border: '1px solid #1e293b' };
const iconBox = { fontSize: '2rem', marginBottom: '15px' };
const tableSection = { padding: '100px 20px', textAlign: 'center', backgroundColor: '#0a0d14' };
const tableContainer = { maxWidth: '800px', margin: '0 auto', border: '1px solid #1e293b', borderRadius: '12px', overflow: 'hidden' };
const tableRow = { display: 'flex', borderBottom: '1px solid #1e293b' };
const tableHeader = { flex: 1, padding: '20px', backgroundColor: '#1e293b', fontWeight: 'bold' };
const tableCell = { flex: 1, padding: '20px', color: '#94a3b8' };
const footerStyle = { padding: '60px 20px', textAlign: 'center', borderTop: '1px solid #1e293b', marginTop: '60px', color: '#94a3b8' };

export default CatalogOptimization;